<script>
import Translatable from '@src/mixins/translatable.js'
import ImageMixin from '@src/mixins/imageMixin.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'

export default {
  props: {
    step: {
      type: Object,
      required: true
    }
  },
  mixins: [
    Translatable,
    SanitizerMixin,
    ImageMixin
  ],
  data() {
    return {
      google: require("../../assets/icons/google-play.svg"),
      apple: require("../../assets/icons/app-store.svg")
    }
  },
  methods: {
    routeLink(data) {
      return data.url ? data.url : `${process.env.VUE_APP_STATIC_URL}${data.pdf}`
    },
  }
}
</script>

<template>
  <div class="card-container">
    <div class="plan-image" :style="getBackgroundSmall(step.image[1])"></div>
    <div class="plan-content">
      <h4 class="plan-title">
        {{ step.title }}
      </h4>
      <p class="plan-text" v-html="textSanitize(step.text)">
      </p>
     <div v-if="step.buttonText" class="button-send-container">
        <div v-if="step._id === 1" class="app-buttons-container">
          <a
            :href="`${step.route.urls[0]}`"
            target="_blank"
            class="link"
          >
            <div class="app-button" :style="{ backgroundImage: `url(${google})` }"></div>
          </a>
          <a
            :href="`${step.route.urls[1]}`"
            target="_blank"
            class="link"
          >
            <div class="app-button" :style="{ backgroundImage: `url(${apple})` }">
            </div>
          </a>
        </div>
        <a v-else :href="`${routeLink(step.route)}`" :target="step._id !== 3 ? '_blank' : ''" :download="step._id === 2 && step._id === 5" class="link" >
          <button class="button-send">{{ getTranslatedContent(step.buttonText) }}</button>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-container {
  display: grid;
  column-gap: 20px;
  width: 100%;
  height: auto;
  grid-template-columns: repeat(2, 1fr);
}

.plan-content {
  min-height: 350px;
  height: auto;
}

h4.plan-title {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $dark-blue;
}

::v-deep.plan-text {
  margin-top: 15px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  // color: rgb(37, 37, 39, 0.8);
  color: $dark-blue;
  min-height: 100px;
  height: auto;
  user-select: none;

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & .ql-align-center {
    text-align: center;
  }
}

.plan-image {
  background-color: $dark-gray;
  display: flex;
  height: 350px;
  justify-content: flex-end;
  align-items: flex-end;
  border-radius: 10px;
  border: none;
  background-size: cover;
  background-position: center;
}

.button-send-container {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 20px 0 0 0;

  .button-send {
    min-width: 194px;
    min-height: 48px;
    border: 1px solid $dark-blue;
    border-radius: 5px;
    background: $dark-blue;
    color: $white;
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-style: normal;
    text-transform: uppercase;
    font-size: 15px;
    line-height: 130%;
    padding: 15px 30px;
    margin-right: 25px;

    &:hover {
      border: 1px solid $hover-blue;
      background: $hover-blue;
    }
  }
}

.app-buttons-container {
  display: flex;
  align-self: center;

  .app-button {
    width: 150px;
    height: 43px;
    border: 1px solid $dark-blue;
    border-radius: 5px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0px 5px;
  }
}

.card-container:nth-child(2n+1) {
  .plan-image {
    order: 2;
  }
  .plan-content {
    order: 1;
  }
}

.link {
  display: block;
  outline: none;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: $container-width-xs) {
  .card-container {
    grid-template-columns: repeat(1, 1fr);
  }

  .card-container:nth-child(1n) {
    .plan-image {
      order: 1;
    }

    .plan-content {
      order: 2;
    }
  }

  .plan-content {
    min-height: 150px;
    padding: 20px 8px;
  }

  .plan-image {
    border-radius: 0;
    height: 200px;
  }

  .button-send-container {
    flex-direction: column;
    padding: 25px 0 0 0;

    .button-send {
      width: 100%;
      padding: 5px 30px;
      margin-right: 0;
    }
  }

  .app-buttons-container {
    width: 100%;
    margin-top: 10px;

    .app-button {
      width: 100%;
      margin: 0;
    }
  }

  .link {
    margin: 3px 0px 0 0;
  }

  .link:first-child {
    margin: 3px 10px 0 0;
  }
}
</style>
